<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "Login",
  title: "Dropsmart Login",
  page: {
    title: "Login",
    meta: [{ name: "description", content: "Login" }],
  },
  components: {
    Header,
    Footer,
    LoginForm,
  },
};
</script>
<template>
  <main>
    <Header />
    <div class="content page-login">
      <LoginForm />
    </div>
    <Footer />
  </main>
</template>
<style lang="scss">
.page-login {
  width: 100%;
}
.content {
  padding-bottom: 10%;
}
</style>
